import { activeProjectVar, tokenVar } from 'modulesCommon/store'
import { queryParamsToString } from 'shared/utils/queryParamsToString'
import { galleryUrlsVar } from 'modules/Feed/store'
import { TFileStatus } from 'shared/types'

const uploaderService = () => {
  const uploadFile = async (
    blob: File | string,
    params: any,
    onProgressCallback: (resolvedLength: number, total: number) => void
  ) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_UPLOAD_URL as string}?${queryParamsToString(params)}`, {
        method: 'POST',
        headers: {
          authorization: tokenVar()
        },
        body: blob
      })

      const resClone = res.clone()

      let receivedLength = 0
      const total = Number(res.headers.get('content-length'))
      const reader = res?.body?.getReader()

      // TODO Refactor to get rid of while true
      // eslint-disable-next-line no-constant-condition
      while (true) {
        const renderRead = await reader?.read()

        if (!renderRead) {
          continue
        }

        const { done, value } = renderRead

        if (done) {
          break
        }

        receivedLength += value.byteLength

        onProgressCallback(receivedLength, total)
      }

      const resCloneData = await resClone.json()

      return resCloneData
    } catch (error) {
      console.log(error)
    }
  }

  const uploadPhoto = (
    blob: File,
    resize: boolean = true,
    onProgressCallback: (resolvedLength: number, total: number) => void
  ) => {
    const params: Record<string, any> = {
      id: activeProjectVar().id,
      image_name: blob.name,
      image_type: blob.type,
      resize,
      ...(blob.type?.includes('pdf') && { pdf: true })
    }

    return uploadFile(blob, params, onProgressCallback)
  }

  return {
    send: (
      fileName: string,
      file: File,
      onProgress: (loaded: number, total: number) => void,
      onStatus: (state: TFileStatus) => void = () => null
    ) => {
      onStatus('progress')

      const controller = new AbortController()
      const uploadedFile = uploadPhoto(file, false, onProgress)

      const res = uploadedFile
        .then((res) => {
          galleryUrlsVar([...galleryUrlsVar(), res.Location])
          onStatus('success')
        })
        .catch((err) => {
          onStatus('error')
        })

      return {
        res,
        abort: () => controller.abort()
      }
    }
  }
}

export default uploaderService
